module.exports = __webpack_public_path__ + "img/018.545211ff.png";